import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FileHistorySchema = withDefaults({
  type: 'file-history',
  traits: ['digital-asset'],
  fields: [
    {
      kind: 'attribute',
      name: 'batch',
    },
    {
      kind: 'attribute',
      name: 'recordType',
    },
    {
      kind: 'attribute',
      name: 'operationId',
    },
    {
      kind: 'attribute',
      name: 'insertedCount',
    },
    {
      kind: 'attribute',
      name: 'sizeConfig',
    },
    {
      kind: 'attribute',
      name: 'totalEmployeeCount',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'processingStartAt',
    },
    {
      kind: 'attribute',
      name: 'processingEndAt',
    },
    {
      kind: 'attribute',
      name: 'fileState',
    },
    {
      kind: 'attribute',
      name: 'fileRecordJson',
    },
    {
      kind: 'attribute',
      name: 'rawFileDigitalAssetFullPath',
    },
    {
      kind: 'attribute',
      name: 'rawFileDigitalAssetFilename',
    },
    {
      kind: 'attribute',
      name: 'rawFileDigitalAssetUploadedFile',
    },
    {
      kind: 'attribute',
      name: 'rawFileDigitalAssetErrorFile',
    },
    {
      kind: 'attribute',
      name: 'rawFileDigitalAssetErrorFileName',
    },
    {
      kind: 'attribute',
      name: 'rawFileDigitalAssetCorrectedFile',
    },
    {
      kind: 'attribute',
      name: 'rawFileDigitalAssetCorrectedFileName',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: 'fileHistories',
      },
    },
    {
      kind: 'belongsTo',
      name: 'rawFileDigitalAsset',
      type: 'raw-file-digital-asset',
      options: {
        async: false,
        inverse: 'fileHistory',
      },
    },
    {
      kind: 'hasMany',
      name: 'fileHistoryLogs',
      type: 'file-history-log',
      options: {
        async: false,
        inverse: 'fileHistory',
      },
    },
  ],
});

export default FileHistorySchema;
